module.exports = __webpack_public_path__ + "media/Shapes/Shape3-d248c22b.svg";